var map = {
	"./de/audio/female_after.mp3": 53631,
	"./de/audio/female_before.mp3": 99330,
	"./de/audio/male_after.mp3": 57524,
	"./de/audio/male_before.mp3": 54959,
	"./en/audio/female_after.mp3": 10359,
	"./en/audio/female_before.mp3": 33114,
	"./en/audio/male_after.mp3": 69068,
	"./en/audio/male_before.mp3": 52359,
	"./es/audio/female_after.mp3": 4056,
	"./es/audio/female_before.mp3": 33459,
	"./es/audio/male_after.mp3": 4943,
	"./es/audio/male_before.mp3": 5042,
	"./fr/audio/female_after.mp3": 26896,
	"./fr/audio/female_before.mp3": 80971,
	"./fr/audio/male_after.mp3": 82215,
	"./fr/audio/male_before.mp3": 49162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89141;